// Module
var code = "<template class=\"ess-ribbon-link\"> <div class=\"ess-folder-tabs\"> <div class=\"ess-tab ess-flex-center\"> <a class=\"ess-flex-vertical ess-ribbon-tab-link\" href.bind=\"url\" ess-tooltip.bind=\"tooltip\" target.bind=\"target\" ess-focusable><slot></slot></a> </div> </div> </template> ";
// Exports
module.exports = code;